// extracted by mini-css-extract-plugin
export default {"text-field":"ChangePasswordForm_text-field__+pS77","form":"ChangePasswordForm_form__v9WCe"};